angular.module("dx.webapp.printing", [
	"dx.webapp.examParts",
	"dx.webapp.question",
	"digiexam.exam",
	"digiexam.node",
	"dx.webapp.event",
	"dx.webapp.exam",
	"dx.webapp.navigation",
	"dx.webapp.question",
	"dx.webapp.accessibility",

	"dx.ui.dataTypes.grading",
	"dx.ui.utils",
	"dx.webapp.angular",
]);
